import { DeliveryOption } from "./DeliveryOption";
import { StandardDeliveryOption } from "./StandardDeliveryOption";
import styles from "./DeliveryOptions.module.scss";

const STANDARD_DELIVERY_HEADLINE = "Standard Delivery";

export type DeliveryOption = {
  headline: string;
  description: string;
  displayPrice: string;
};

type Props = {
  skuId: string;
  isAvailableToOrderOrPreorder: boolean;
  deliveryOptions: DeliveryOption[];
  stockApiBaseUrl: string;
  stockApiKey: string;
};

export function DeliveryOptions({
  skuId,
  isAvailableToOrderOrPreorder,
  deliveryOptions,
  stockApiBaseUrl,
  stockApiKey,
}: Props) {
  return (
    <>
      <h2 className={styles.subTitle}>Delivery and collection options</h2>
      <dl data-testid="delivery:options" className={styles.deliveryOptions}>
        {deliveryOptions.map((option, index) => (
          <div key={index} className={styles.option}>
            {option.headline === STANDARD_DELIVERY_HEADLINE ? (
              <StandardDeliveryOption
                index={index}
                skuId={skuId}
                isAvailableToOrderOrPreorder={isAvailableToOrderOrPreorder}
                {...option}
                stockApiBaseUrl={stockApiBaseUrl}
                stockApiKey={stockApiKey}
              />
            ) : (
              <DeliveryOption index={index} {...option} />
            )}
          </div>
        ))}
      </dl>
    </>
  );
}
